import React from "react";
import PropTypes from "prop-types";
import FilterCheck from "../FilterCheck";
import "./style.scss";

export default class FilterBank extends React.Component {
  render() {
    const {renderBank} = this.props;
    return renderBank ? (
      renderBank({...this.props})
    ) : (
      <div className="filterBank">
        {this.props.data.map((item, index) => {
          return <FilterCheck key={item._id} {...this.props} name={item._id} label={item.name} />;
        })}
      </div>
    );
  }
}

FilterBank.propTypes = {
  data: PropTypes.array,
  filter: PropTypes.object,
  path: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  renderBank: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/FilterBank/index.jsx